export const appsBusinessUsage = "/apps/business/usage";
